<template>
    <keep-alive>
        <div id="admin-nav-container">
            <div v-if="adminData" class="flex flex-row">
                <div class="sub-nav-item-label">Environment: {{ adminData.app_env }}</div>
                <div class="sub-nav-item-label" v-if="adminData.app_status === '0'">Portal Offline</div>
                <div class="sub-nav-item-label"> ⸱ Role: {{ adminData.role }}</div>
                <div class="sub-nav-item-label"> ⸱ Branch: {{ adminData.github_branch }}</div>
                <div class="sub-nav-item-label" v-if="adminData.email_disabled !== '0'"> ⸱ Email notifications inactive</div>
                <div class="sub-nav-item-label" v-if="adminData.email_debug_active !== '0'"> ⸱ Email debug active [to: {{adminData.email_debug_addresses}}]</div>
                <div class="sub-nav-item-label" v-if="adminData.sync_branch"> ⸱ Sync Disabled</div>
            </div>
            <div v-else>
                Loading...
            </div>
        </div>
    </keep-alive>
</template>
email_debug_active
email_debug_addresses

<script>

import axios from "axios";

export default {
    name: "AdminNavBar",
    beforeMount() {
        axios.get('/admin/portal-meta-data')
            .then(response => {
                this.adminData = response.data;
            })
    },
    data() {
        return {adminData: null}
    },
}
</script>

<style scoped>
.sub-nav-item-label {
    margin: 0 2px;
}

#admin-nav-container {
    background: #181515;
    color: #fff;
    font-size: 12px;
    padding: 3px;
    font-weight: 600;
}
</style>
